const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSliderHome: $('.js-slider'),
	$domSliderHomePrev: $('.js-slider-left__arr-prev'),
	$domSliderHomeNext: $('.js-slider-left__arr-next'),

	/** @description Initialize. */
	init: function() {
		this.initSliderHome();
	},

	/** @description Set and run gallery slider. */

	initSliderHome: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			autoplaySpeed: 3000,
			variableWidth: true,
			arrows: true,
			prevArrow: Sliders.$domSliderHomePrev,
			nextArrow: Sliders.$domSliderHomeNext,
			slidesToShow: 2,
			slidesToScroll: 1,
			dots: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderHome, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
